<button mat-menu-item [matMenuTriggerFor]="siteMenu">
  <mat-icon>
    <span class="wk-icon-folder"></span>
  </mat-icon>
  {{ siteName }}
  <div class="site-lib" *ngIf="siteName != 'My sites' && isAnySiteAvailable">
    {{ 'APP.CURRENT_USER.LIBRARY' | translate }}
  </div>
</button>
<mat-menu #siteMenu="matMenu">
  <button
    mat-menu-item
    *ngFor="let site of sites"
    (click)="selectSite(site)"
    (keyup)="selectSite(site)"
  >{{ site.title }}</button>
</mat-menu>
